import * as React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Card, ListItemButton } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { ngWalletMenuItems } from '../../constants/ngWalletMenuItems';

const DesktopSidebar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    return (
        // Reduced overall width and tightened spacing to make the sidebar more compact
        <Box sx={{ width: 200, display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* Logo/Brand */}
            <Card sx={{ p: 1, bgcolor: 'primary.main', color: 'white', textAlign: 'center' }}>
                <Typography variant="body2" fontWeight="bold">
                    NG Credit
                </Typography>
            </Card>

            {/* Menu Sections */}
            <Box sx={{ overflowY: 'auto', flex: 1 }}>
                {ngWalletMenuItems.map((section) => (
                    <Box key={section.title} sx={{ mb: 1.25 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                color: 'text.secondary',
                                px: 1,
                                display: 'block',
                                mb: 0.5,
                                fontSize: '0.6rem',
                            }}
                        >
                            {section.title}
                        </Typography>
                        <List sx={{ p: 0 }}>
                            {section.items.map((item) => (
                                // Reduce vertical padding and tighten hover spacing
                                <ListItem key={item.link} disablePadding sx={{ mb: 0.15 }}>
                                    <ListItemButton
                                        onClick={() => navigate(item.link)}
                                        sx={{
                                            borderRadius: 1,
                                            bgcolor: isActive(item.link) ? 'primary.main' : 'transparent',
                                            color: isActive(item.link) ? 'white' : 'inherit',
                                            '&:hover': {
                                                bgcolor: isActive(item.link) ? 'primary.main' : 'action.hover',
                                            },
                                            transition: 'all 0.12s ease',
                                            px: 0.75,
                                            py: 0.4,
                                            minHeight: 34,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                color: isActive(item.link) ? 'white' : 'primary.main',
                                                minWidth: 28,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {/* Many icons in the codebase accept a `size` prop; keep it but reduce to 16 */}
                                            <item.icon size={16} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    variant="body2"
                                                    noWrap
                                                    sx={{
                                                        fontWeight: isActive(item.link) ? 600 : 500,
                                                        fontSize: '0.8rem',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default DesktopSidebar;